






















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { StatusType } from "../../enums/StatusType";
import container from "../../inversify.config";
import Loader from "@/components/Loader.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

const PropertyManagementModule = namespace("propertyManagementModule");

@Component({
  components: {
    Loader,
    SuccessMessage
  }
})
export default class PropertyAdvertisingControls extends Vue {
  @PropertyManagementModule.Action public updateAdvertisingControls;

  @Prop() public property: IProperty;

  @Prop() public loading: boolean;

  private lastSaved: Date | null = null;

  private submitForm() {
    this.updateAdvertisingControls(this.property).then((result) => {
        if (result) {
        this.lastSaved = new Date();
        }
    });
  }
}
